import "./banner.css";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import StarIcon from "../../../assets/svg/star-fill.svg";
import CardUpImg from "../../../assets/images/NZ_Home_Baner.png";
const NZBanner = () => {
  useEffect(() => {
    const videoElement = document.querySelector("video");
    if (videoElement) {
      videoElement.play().catch((error) => {
        console.error("Autoplay failed:", error);
      });
    }
  }, []);

  const navigate = useNavigate();
  return (
    <div className="
  relative 
  min-h-[70vh] 
  md:min-h-[600px] 
  lg:min-h-[600px] 
  xl:min-h-[700px]
  overflow-hidden
"
    >
      <video
        className="absolute inset-0 w-full h-full object-cover"
        src="https://vizybilitystorage.blob.core.windows.net/videos/DMSDb_ALPHAOMEGA/WebApp/TuataraUSABanner.9348ec7ef8058df4b5cf.mp4?sp=r&st=2024-11-26T16:01:07Z&se=2028-12-31T00:01:07Z&spr=https&sv=2022-11-02&sr=b&sig=jY1JkjWRw0a4lXJ25ZeKmaASjx4WnVS%2Bmt2My%2FIj0eo%3D"
        loop
        muted
        playsInline
        preload="auto"
        onCanPlay={(e) => e.target.play()}
      ></video>
      <div className="absolute inset-0 flex items-center justify-center p-4">
        <div className="
          bg-[rgba(0,0,0,0.55)]
          p-6 sm:p-8 md:p-12 lg:p-14
          w-full sm:w-[90%] md:w-full
          max-w-[750px] lg:max-w-[900px]
          text-center
          rounded-xl
          text-white
          
          shadow-lg
        ">

          {/* H1 */}
          <h1 className="kuunari-bold text-[22px] sm:text-[32px] md:text-[42px] lg:text-[48px] leading-[1.2] mb-4">
            Introducing the Most Capable Side-by-Side Utility Vehicle in NZ
          </h1>

          {/* Subheading */}
          <p className="montserrat-semi-bold text-[14px] sm:text-[16px] md:text-[20px] lg:text-[22px] leading-relaxed mb-6">
            When the terrain is rough, and the workload doesn’t ease up, you need an ATV vehicle built for real work. Tuatara side-by-side utility vehicles are designed tough, with steel construction and the towing power to back it up. They’re designed for long days on farms, commercial sites and rough ground around New Zealand.
          </p>

          {/* Intro paragraph */}
          <p className="montserrat-medium text-[12px] sm:text-[14px] md:text-[16px] lg:text-[18px] leading-relaxed mb-8">
            Explore the full Tuatara range and find the right ATV for your property, project or fleet.
          </p>

          {/* CTA */}
          <button
            onClick={() => navigate("/nz/ContactUs")}
            className="bg-[#6FBF4A] text-white px-6 py-3 sm:px-8 sm:py-4 text-[14px] sm:text-[16px] font-bold uppercase rounded hover:bg-[#5daf39] transition duration-300"
          >
            Contact Us
          </button>

        </div>
      </div>

      {/* <img src={CardUpImg} className=" relative top-0 left-0 w-full h-full object-cover" /> */}
      {/* <div className=" md:bg-transparent bg-[#000] md:py-0 py-[50px]">
        <div className="relative z-1 flex flex-col items-end justify-center h-auto md:h-[calc(100svh-100px)] text-end text-white custom-container">
          <div className="md:max-w-[560px] w-auto p-[30px] bg-[rgba(56,56,56,0.64)] ">
            <div className="banner-nz-text kuunari-bold">PURCHASE THE MOST VERSATILE SIDE-BY-SIDE</div>
            <div className="banner-nz-sub-text mt-[10px]  montserrat-medium text-[16px] leading-[24px]">
              Our ATV side-by-side vehicles (Electric and Petrol) are purpose-built for off-road running and designed
              specially to be every farmer’s primary workhorse, but the real strength of the Tuatara UTV is its versatility, making it ideal for a wide range of activities, including farming, horticulture, agricultural contracting, hunting, golf courses, retirement villages, mining, zoos, district council ground works, airports, power stations, civil construction, fighting forest fires… and the list goes on.  We know this because we have supplied Tuataras to every one of the occupations listed.
              <br/>
              Reliability and low maintenance are the name of the game,s and you need not look any further than the Tuatara to meet those requirements And while the TUATARA is often categorised as an ATV, it is more correctly an off-road utility vehicle (UTV) because frankly the Tuatara will go where the others can’t, and it will carry more and tow more than its rivals, if it has any.  
            </div>
            <p className="flex  mt-[17px]">
              <span className="banner-nz-sub-text flex items-center justify-center mr-[5px] montserrat-semi-bold text-[16px] leading-[24px]">
                <img src={StarIcon} alt="" className="w-[16px]" />
                Powerful!
              </span>
              <span className="banner-nz-sub-text flex items-center justify-center mr-[5px] montserrat-semi-bold text-[16px] leading-[24px]">
                <img src={StarIcon} alt="" className="w-[16px]" />
                Go Anywhere
              </span>
              <span className="banner-nz-sub-text flex items-center justify-center mr-[5px] montserrat-semi-bold text-[16px] leading-[24px]">
                <img src={StarIcon} alt="" className="w-[16px]" />
                Versatile
              </span>
              <span className="banner-nz-sub-text flex items-center justify-center montserrat-semi-bold text-[16px] leading-[24px]">
                <img src={StarIcon} alt="" className="w-[16px]" />
                Low Maintenance
              </span>
            </p>
          </div>
        </div>
      </div> */}
    </div>
  );
};
export default NZBanner;
